<template>
  <div class="print-booking-confirm-main">
    <div class="booking-options">
      <div class="filters-and-table-box-controls">
        <div class="filters-summary-container">
          <span>{{ filterText }}</span>
        </div>
        <ButtonFilter
          buttonText="Change Filter"
          filterPosition="right"
          :filterWidth="420"
          :isOpen.sync="mainFilterIsOpen"
        >
          <div class="button-filter-content-container">
            <BoxContainer
              class="date-filter-container"
              :title="`Booking Date`"
              :isCheckBox="true"
              :isChecked.sync="dateFilterChecked"
            >
              <DateTimePicker
                :placeholder="`Start`"
                :value.sync="refreshStart"
                :showTime="false"
                :isDisabled="!dateFilterChecked"
              />
              <DateTimePicker
                :placeholder="`End`"
                :value.sync="refreshEnd"
                :showTime="false"
                :isDisabled="!dateFilterChecked"
              />
            </BoxContainer>

            <BoxContainer
              class="booking-no-filter-container"
              title="Search"
              :isChecked.sync="searchFilterChecked"
              :isCheckBox="true"
              style="margin-bottom: 5px"
            >
              <Dropdown
                placeholder="Search By"
                :items="searchFilterItems"
                itemKey="Search Criteria"
                :isDisabled="!searchFilterChecked"
                :isRequired="searchFilterChecked"
                :selectedObject.sync="selectedSearchBy"
                :errorMessage.sync="searchByError"
                @selected="searchBySelected"
                validator="text,40"
              />
              <Dropdown
                placeholder="Search Criteria"
                :items="searchCriteriaItems"
                itemKey="name"
                :isDisabled="!searchFilterChecked || criteriaDisabled"
                :isRequired="searchFilterChecked"
                :selectedObject.sync="selectedCriteria"
                validator="text,40"
              />
              <Input
                placeholder="Search"
                :inputValue.sync="searchByValue"
                :isDisabled="!searchFilterChecked"
                :isRequired="searchFilterChecked"
                :errorMessage.sync="searchByValueError"
              />
            </BoxContainer>
            <div class="refresh-button-container">
              <button @click="refreshFilterClicked" :disabled="!dateFilterChecked && !searchFilterChecked">
                Refresh
              </button>
            </div>
          </div>
        </ButtonFilter>
      </div>

      <div class="table-box-container">
        <TableBox
          :tableData="printList"
          title="Freight Job"
          :selectedRow.sync="selectedFreightBooking"
          :loading="tableLoading"
          :selectedIndex="selectedIndex"
          @rowSelected="freightBookingSelected"
        />
      </div>
      <!-- start here -->
      <div class="popup-details" id="popupDetails">
        <Tab :style="{ width: '100%' }" :tabs="tabsItems" :tabIndex.sync="currentTabIndex">
          <div slot="Importer/Exporter">
            <div class="tab-block">
              <div class="tab-title">Importer/Consignee</div>
              <div class="details-column">
                <Input placeholder="Name" :inputValue.sync="detailsConsignee['name']" validator="text,100" />
                <AddressFormV2
                  :address.sync="detailsConsignee"
                  :addressRequired="consigneeAddressRequired"
                  :addressErrors.sync="consigneeAddressErrors"
                  :postcodes="addressDetails.postcodeList"
                  :states="addressDetails.stateList"
                  :countries="addressDetails.countryList"
                />
                <Input placeholder="Attn To" :inputValue.sync="detailsConsignee['attn']" validator="text,100" />
                <div style="display: flex">
                  <Input
                    placeholder="Tel #"
                    style="padding-right: 5px"
                    :inputValue.sync="detailsConsignee['tel']"
                    validator="text,20"
                  />
                  <Input
                    placeholder="Fax #"
                    style="padding-left: 5px"
                    :inputValue.sync="detailsConsignee['fax']"
                    validator="text,20"
                  />
                </div>
              </div>
            </div>
            <div class="tab-block">
              <div class="tab-title">Exporter/Shipper</div>
              <div class="details-column">
                <Input placeholder="Name" :inputValue.sync="detailsShipper['name']" validator="text,100" />
                <AddressFormV2
                  :address.sync="detailsShipper"
                  :addressRequired="shipperAddressRequired"
                  :addressErrors.sync="shipperAddressErrors"
                  :postcodes="addressDetails.postcodeList"
                  :states="addressDetails.stateList"
                  :countries="addressDetails.countryList"
                />
                <Input placeholder="Attn To" :inputValue.sync="detailsShipper['attn']" validator="text,100" />
                <div style="display: flex">
                  <Input
                    placeholder="Tel #"
                    style="padding-right: 5px"
                    :inputValue.sync="detailsShipper['tel']"
                    validator="text,20"
                  />
                  <Input
                    placeholder="Fax #"
                    style="padding-left: 5px"
                    :inputValue.sync="detailsShipper['fax']"
                    validator="text,20"
                  />
                </div>
              </div>
            </div>
          </div>
          <div slot="Notify Party/Oversea Agt">
            <div class="tab-block">
              <div class="tab-title">Notify Party</div>
              <div class="details-column">
                <Input placeholder="Name" :inputValue.sync="detailsNParty['name']" validator="text,100" />
                <AddressFormV2
                  :address.sync="detailsNParty"
                  :postcodes="addressDetails.postcodeList"
                  :states="addressDetails.stateList"
                  :countries="addressDetails.countryList"
                />
                <Input placeholder="Attn To" :inputValue.sync="detailsNParty['attn']" validator="text,100" />
                <div style="display: flex">
                  <Input
                    placeholder="Tel #"
                    style="padding-right: 5px"
                    :inputValue.sync="detailsNParty['tel']"
                    validator="text,20"
                  />
                  <Input
                    placeholder="Fax #"
                    style="padding-left: 5px"
                    :inputValue.sync="detailsNParty['fax']"
                    validator="text,20"
                  />
                </div>
              </div>
            </div>
            <div class="tab-block">
              <div class="tab-title">Oversea Agent</div>
              <div class="details-column">
                <Input placeholder="Name" :inputValue.sync="detailsOAgent['name']" validator="text,100" />
                <AddressFormV2
                  :addressRequired="OAgentAddressRequired"
                  :addressErrors.sync="OAgentAddressErrors"
                  :address.sync="detailsOAgent"
                  :postcodes="addressDetails.postcodeList"
                  :states="addressDetails.stateList"
                  :countries="addressDetails.countryList"
                />
                <Input placeholder="Attn To" :inputValue.sync="detailsOAgent['attn']" validator="text,100" />
                <div style="display: flex">
                  <Input
                    placeholder="Tel #"
                    style="padding-right: 5px"
                    :inputValue.sync="detailsOAgent['tel']"
                    validator="text,20"
                  />
                  <Input
                    placeholder="Fax #"
                    style="padding-left: 5px"
                    :inputValue.sync="detailsOAgent['fax']"
                    validator="text,20"
                  />
                </div>
              </div>
            </div>
          </div>
          <div slot="Other BL Details">
            <div class="details-column">
              <Input
                :isRequired="true"
                placeholder="# of Original BL issued"
                :inputValue.sync="printDetails['originalBLNo']"
                :errorMessage.sync="blErrorMessage"
                validator="positiveDecimal,2"
              />
              <RemarksBox
                title="Freight Details, Charge and Remarks"
                :text.sync="printDetails['remarks']"
                style="height: 120px"
                :maxLength="160"
              />
              <RemarksBox
                title="Signature Caption"
                :text.sync="printDetails['caption']"
                style="height: 120px"
                :maxLength="90"
              />
            </div>
          </div>
        </Tab>
        <div class="call-to-action-buttons">
          <div class="format-dropdown">
            <Dropdown
              placeholder="Layout Type"
              :items="formatItems"
              itemKey="name"
              :selectedObject.sync="formatSelectedObject"
              :isRequired="true"
              :errorMessage.sync="formatErrorMessage"
            />
            <button @click="previewClicked">Preview Report</button>
          </div>
        </div>
      </div>
    </div>
    <div class="report-preview">
      <DesignerV2
        v-if="showDesignerV3"
        :viewMode="true"
        :reportData="designerV3ReportData"
        reportFolder="HBLForm"
        :reportFile="designerV3ReportFiles"
        :canShare="true"
        :canClose="false"
      />
      <div v-else class="user-instructions">
        <span>Select Booking and click on <strong>Preview Report</strong> to get started</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  computed: {},
  data: function () {
    return {
      tabsItems: [
        { title: 'Importer/Exporter', disabled: false },
        { title: 'Notify Party/Oversea Agt', disabled: false },
        { title: 'Other BL Details', disabled: false },
      ],
      formatItems: [],
      formatSelectedObject: null,
      formatErrorMessage: '',
      currentTabIndex: 0,
      detailsConsignee: {
        name: '',
        attn: '',
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        addressLine4: '',
        postcode: '',
        city: '',
        state: '',
        country: '',
      },
      detailsShipper: {
        name: '',
        attn: '',
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        addressLine4: '',
        postcode: '',
        city: '',
        state: '',
        country: '',
      },
      detailsNParty: {
        name: '',
        attn: '',
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        addressLine4: '',
        postcode: '',
        city: '',
        state: '',
        country: '',
      },
      detailsOAgent: {
        name: '',
        attn: '',
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        addressLine4: '',
        postcode: '',
        city: '',
        state: '',
        country: '',
      },
      consigneeAddressRequired: {
        addressLine1: true,
        addressLine2: false,
        addressLine3: false,
        addressLine4: false,
        postcode: false,
        city: false,
        state: false,
        country: false,
      },
      consigneeAddressErrors: {
        addressLine1: '',
      },
      shipperAddressRequired: {
        addressLine1: true,
        addressLine2: false,
        addressLine3: false,
        addressLine4: false,
        postcode: false,
        city: false,
        state: false,
        country: false,
      },
      shipperAddressErrors: {
        addressLine1: '',
      },
      OAgentAddressRequired: {
        addressLine1: true,
        addressLine2: false,
        addressLine3: false,
        addressLine4: false,
        postcode: false,
        city: false,
        state: false,
        country: false,
      },
      OAgentAddressErrors: {
        addressLine1: '',
      },
      blErrorMessage: '',
      addressDetails: {
        postcodeList: [],
        stateList: [],
        countryList: [],
      },
      selectedIndex: [],
      routeWithBookingNo: false,
      mainFilterIsOpen: false,
      dateFilterChecked: true,
      searchFilterChecked: false,
      refreshStart: new Date(new Date().setDate(new Date().getDate() - 3)),
      refreshEnd: new Date(),
      searchFilterItems: [
        { 'Search Criteria': 'Booking #', '#': 1 },
        { 'Search Criteria': 'Job #', '#': 2 },
        { 'Search Criteria': 'BL No #', '#': 3 },
        { 'Search Criteria': 'Cargo Type', '#': 4 },
        { 'Search Criteria': 'Shipper/Consignee', '#': 5 },
        { 'Search Criteria': 'Billing Customer', '#': 6 },
        { 'Search Criteria': 'Project #', '#': 7 },
        { 'Search Criteria': 'Container #', '#': 8 },
        { 'Search Criteria': 'Transport Mode', '#': 9 },
        { 'Search Criteria': 'Customer Ref #', '#': 10 },
        { 'Search Criteria': 'Vessel Name', '#': 11 },
        { 'Search Criteria': 'Mother Vessel Name', '#': 12 },
        { 'Search Criteria': 'Vessel Booking Ref #', '#': 13 },
        { 'Search Criteria': 'User ID', '#': 14 },
        { 'Search Criteria': 'Container Type', '#': 15 },
        { 'Search Criteria': 'Goods Description', '#': 16 },
      ],
      searchCriteriaItems: [{ name: 'EQUALS' }, { name: 'STARTS WITH' }, { name: 'CONTAINS' }, { name: 'ENDS WITH' }],
      selectedSearchBy: null,
      criteriaDisabled: false,
      selectedCriteria: null,
      searchByValue: '',
      searchByError: '',
      searchByValueError: '',
      filterText: '',

      bookingDetails: null,
      printList: [],
      tableLoading: false,
      selectedBookingNo: '',
      loginDetails: null,
      printDetails: {
        originalBLNo: '',
        remarks: '',
        caption: '',
      },

      showDesignerV3: false,
      designerV3ReportFiles: [],
      designerV3ReportData: [],
      selectedFreightBooking: [],
    };
  },
  props: {},
  methods: {
    refreshFilterClicked: async function () {
      this.printList = [];
      this.selectedFreightBooking = [];
      this.selectedBookingNo = '';

      if (this.dateFilterChecked && this.searchFilterChecked) {
        this.filterText = `Filter by ${this.selectedSearchBy['Search Criteria']} ${this.selectedCriteria['name']} ${this.searchByValue}, from ${new Date(this.refreshStart).formatString('yyyy-MM-dd')} to ${new Date(this.refreshEnd).formatString('yyyy-MM-dd')}`;
      } else if (this.dateFilterChecked && !this.searchFilterChecked) {
        this.filterText = `Filter by date from ${new Date(this.refreshStart).formatString('yyyy-MM-dd')} to ${new Date(this.refreshEnd).formatString('yyyy-MM-dd')}`;
      } else if (!this.dateFilterChecked && this.searchFilterChecked) {
        this.filterText = `Filter by ${this.selectedSearchBy['Search Criteria']} ${this.selectedCriteria['name']} ${this.searchByValue}`;
      }

      const dataToPost = {
        stjobdate: this.dateFilterChecked ? new Date(this.refreshStart).formatString('yyyy-MM-dd') : '',
        edjobdate: this.dateFilterChecked ? new Date(this.refreshEnd).formatString('yyyy-MM-dd') : '',
        jobtype: 'E',
        searchfield: this.searchFilterChecked ? this.selectedSearchBy['Search Criteria'] : '',
        searchcriteria: this.searchFilterChecked ? this.selectedCriteria['name'] : '',
        searchvalue: this.searchFilterChecked ? this.searchByValue : '',
      };
      this.tableLoading = true;
      this.$fullscreenLoading('Getting Booking Details');
      this.printList = (await this.$apiCallV2(`/FreightBooking/GetFreightBookingListing`, dataToPost)).filter(
        (item) => item['Job No'] && item['Job No'].trim() !== '',
      ); // remove items with empty 'Job No'
      this.tableLoading = false;
      this.$fullscreenLoading();
      this.mainFilterIsOpen = false;
    },
    searchBySelected: function (e) {
      if (e) {
        if (e['Search Criteria'] == 'Required Date') {
          this.selectedCriteria = this.searchCriteriaItems[0];
          this.criteriaDisabled = true;
        } else {
          this.criteriaDisabled = false;
        }
      }
    },
    freightBookingSelected: async function (_a, b) {
      this.clearPopupData();
      if (!b) {
        return;
      }
      this.$fullscreenLoading('Getting Details');
      const getJobDetails = await this.$apiCallV2('/Master/GetDetailsMaster', {
        masterfile: 'FREIGHTBOOKING',
        recordid: this.selectedFreightBooking[0]['Booking No'].trim(),
      });

      //console.log('getJobDetails', getJobDetails);
      const details = getJobDetails['Booking'];
      this.detailsShipper.name = details['Shipper Name1'] || '';
      this.detailsShipper.addressLine1 = details['Shipper Add1'] || '';
      this.detailsShipper.addressLine2 = details['Shipper Add2'] || '';
      this.detailsShipper.addressLine3 = details['Shipper Add3'] || '';
      this.detailsShipper.addressLine4 = details['Shipper Add4'] || '';
      this.detailsShipper.postcode = details['Shipper PostCode'] || '';
      this.detailsShipper.city = details['Shipper City'] || '';
      this.detailsShipper.state = details['Shipper State'] || '';
      this.detailsShipper.country = details['Shipper Country'] || '';
      this.detailsShipper.attn = details['Shipper Attn'] || '';
      this.detailsShipper.tel = details['Shipper Tel'] || '';
      this.detailsShipper.fax = details['Shipper Fax'] || '';

      this.detailsConsignee.name = details['Consignee Name1'] || '';
      this.detailsConsignee.addressLine1 = details['Consignee Add1'] || '';
      this.detailsConsignee.addressLine2 = details['Consignee Add2'] || '';
      this.detailsConsignee.addressLine3 = details['Consignee Add3'] || '';
      this.detailsConsignee.addressLine4 = details['Consignee Add4'] || '';
      this.detailsConsignee.postcode = details['Consignee PostCode'] || '';
      this.detailsConsignee.city = details['Consignee City'] || '';
      this.detailsConsignee.state = details['Consignee State'] || '';
      this.detailsConsignee.country = details['Consignee Country'] || '';
      this.detailsConsignee.attn = details['Consignee Attn'] || '';
      this.detailsConsignee.tel = details['Consignee Tel'] || '';
      this.detailsConsignee.fax = details['Consignee Fax'] || '';

      this.detailsNParty.name = details['NParty Name1'] || '';
      this.detailsNParty.addressLine1 = details['NParty Add1'] || '';
      this.detailsNParty.addressLine2 = details['NParty Add2'] || '';
      this.detailsNParty.addressLine3 = details['NParty Add3'] || '';
      this.detailsNParty.addressLine4 = details['NParty Add4'] || '';
      this.detailsNParty.postcode = details['NParty PostCode'] || '';
      this.detailsNParty.city = details['NParty City'] || '';
      this.detailsNParty.state = details['NParty State'] || '';
      this.detailsNParty.country = details['NParty Country'] || '';
      this.detailsNParty.attn = details['NParty Attn'] || '';
      this.detailsNParty.tel = details['NParty Tel'] || '';
      this.detailsNParty.fax = details['NParty Fax'] || '';

      this.detailsOAgent.name = details['Oversea Agent Desc'] || '';
      this.detailsOAgent.addressLine1 = details['OA Addr1'] || '';
      this.detailsOAgent.addressLine2 = details['OA Addr2'] || '';
      this.detailsOAgent.addressLine3 = details['OA Addr3'] || '';
      this.detailsOAgent.addressLine4 = details['OA Addr4'] || '';
      this.detailsOAgent.postcode = details['OA PostCode'] || '';
      this.detailsOAgent.city = details['OA City'] || '';
      this.detailsOAgent.state = details['OA State'] || '';
      this.detailsOAgent.country = details['OA Country'] || '';
      this.detailsOAgent.attn = details['OA Attn'] || '';
      this.detailsOAgent.tel = details['OA Tel'] || '';
      this.detailsOAgent.fax = details['OA Fax'] || '';
      this.printDetails['originalBLNo'] = details['No. of Original BLs'] || '';

      this.$fullscreenLoading();

      // const jobDetails = getJobDetails['Booking']['Job'];
      // const blDetails = getJobDetails['Booking']['Job']['BL'];
      // this.printDetails = details;
    },
    previewClicked: function () {
      this.mainFilterIsOpen = false;
      if (this.selectedFreightBooking.length == 0) {
        this.$showAlert('error', 'No Record Selected', `Please select a record to Preview House BL`);
      } else {
        const errors = [];

        if (!this.formatSelectedObject) {
          this.formatErrorMessage = 'Layout Type is required!';
          errors.push('Layout Type is required!');
        }

        if (!this.detailsShipper.addressLine1.trim()) {
          this.shipperAddressErrors.addressLine1 = 'Shipper Address Line 1 is required!';
          errors.push('Shipper Address Line 1 is required!');
        }

        if (!this.detailsConsignee.addressLine1.trim()) {
          this.consigneeAddressErrors.addressLine1 = 'Consignee Address Line 1 is required!';
          errors.push('Consignee Address Line 1 is required!');
        }

        if (!this.detailsOAgent.addressLine1.trim()) {
          this.OAgentAddressErrors.addressLine1 = 'Oversea Agent Address Line 1 is required!';
          errors.push('Oversea Agent Address Line 1 is required!');
        }

        if (!this.printDetails['originalBLNo']) {
          this.blErrorMessage = 'Please specify the number of Original BL issued!';
          errors.push('Number of Original BL No is required!');
        }

        if (errors.length > 0) {
          this.$showAlert(
            'error',
            'Validation Error',
            `<ul style="text-align: left;">${errors.map((e) => `<li>${e}</li>`).join('')}</ul>`,
          );
          return;
        }
        this.selectedBookingNo = this.selectedFreightBooking[0]['Booking No'].trim();
        //this.refreshListing();
        this.previewBookingConfirmationReport();
      }
    },
    clearPopupData: function () {
      const clearValues = (obj) => {
        Object.keys(obj).forEach((k) => {
          obj[k] = '';
        });
      };

      clearValues(this.detailsConsignee);
      clearValues(this.detailsShipper);
      clearValues(this.detailsNParty);
      clearValues(this.detailsOAgent);
      clearValues(this.consigneeAddressErrors);
      clearValues(this.shipperAddressErrors);
      clearValues(this.OAgentAddressErrors);

      clearValues(this.printDetails);
      this.blErrorMessage = '';
    },
    refreshListing: async function () {
      let dataToPost = {};
      if (this.routeWithBookingNo == false) {
        dataToPost = {
          stjobdate: this.dateFilterChecked ? new Date(this.refreshStart).formatString('yyyy-MM-dd') : '',
          edjobdate: this.dateFilterChecked ? new Date(this.refreshEnd).formatString('yyyy-MM-dd') : '',
          jobtype: 'E',
          searchfield: this.searchFilterChecked ? this.selectedSearchBy['Search Criteria'] : '',
          searchcriteria: this.searchFilterChecked ? this.selectedCriteria['name'] : '',
          searchvalue: this.searchFilterChecked ? this.searchByValue : '',
        };
      } else {
        dataToPost = {
          jobtype: 'E',
          searchfield: 'Booking #',
          searchcriteria: 'EQUALS',
          searchvalue: this.selectedBookingNo,
        };
      }
      this.tableLoading = true;
      this.$fullscreenLoading('Getting Booking Details');

      //reset to empty
      this.printList = [];
      this.selectedFreightBooking = [];

      //call api
      this.printList = (await this.$apiCallV2(`/FreightBooking/GetFreightBookingListing`, dataToPost)).filter(
        (item) => item['Job No'] && item['Job No'].trim() !== '',
      ); // remove items with empty 'Job No'
      this.tableLoading = false;

      if (this.printList.length > 0) {
        // Find the index of the booking that matches `selectedBookingNo`
        const index = this.printList.findIndex((item) => item['Booking No'] === this.selectedBookingNo);

        if (index !== -1) {
          this.$nextTick(() => {
            this.selectedFreightBooking = [this.printList[index]]; // Select the record
            this.selectedIndex = [index]; // Using this prop to highlight the row in TableBox, because the above code doesn't work
            this.freightBookingSelected(true, true); // Call the method to populate the details
          });
        }
      }

      this.$fullscreenLoading();
    },
    previewBookingConfirmationReport: async function () {
      this.bookingDetails = null; //reset booking details
      this.designerV3ReportData = []; //reset report data

      this.bookingDetails = await this.$apiCallV2('/Master/GetDetailsMaster', {
        masterfile: 'FREIGHTBOOKING',
        recordid: this.selectedBookingNo,
      });

      this.$fullscreenLoading('Preparing to Print');

      //wrap object into array
      if (!Array.isArray(this.bookingDetails.Booking)) {
        this.bookingDetails.Booking = [this.bookingDetails.Booking];
      }

      //insert user input into report data
      this.bookingDetails.Booking[0]['Consignee Name1'] = this.detailsConsignee.name || '';
      this.bookingDetails.Booking[0]['Consignee Add1'] = this.detailsConsignee.addressLine1 || '';
      this.bookingDetails.Booking[0]['Consignee Add2'] = this.detailsConsignee.addressLine2 || '';
      this.bookingDetails.Booking[0]['Consignee Add3'] = this.detailsConsignee.addressLine3 || '';
      this.bookingDetails.Booking[0]['Consignee Add4'] = this.detailsConsignee.addressLine4 || '';
      this.bookingDetails.Booking[0]['Consignee PostCode'] = this.detailsConsignee.postcode || '';
      this.bookingDetails.Booking[0]['Consignee City'] = this.detailsConsignee.city || '';
      this.bookingDetails.Booking[0]['Consignee State'] = this.detailsConsignee.state || '';
      this.bookingDetails.Booking[0]['Consignee Country'] = this.detailsConsignee.country || '';
      this.bookingDetails.Booking[0]['Consignee Attn'] = this.detailsConsignee.attn || '';
      this.bookingDetails.Booking[0]['Consignee Tel'] = this.detailsConsignee.tel || '';
      this.bookingDetails.Booking[0]['Consignee Fax'] = this.detailsConsignee.fax || '';

      this.bookingDetails.Booking[0]['Shipper Name1'] = this.detailsShipper.name || '';
      this.bookingDetails.Booking[0]['Shipper Add1'] = this.detailsShipper.addressLine1 || '';
      this.bookingDetails.Booking[0]['Shipper Add2'] = this.detailsShipper.addressLine2 || '';
      this.bookingDetails.Booking[0]['Shipper Add3'] = this.detailsShipper.addressLine3 || '';
      this.bookingDetails.Booking[0]['Shipper Add4'] = this.detailsShipper.addressLine4 || '';
      this.bookingDetails.Booking[0]['Shipper PostCode'] = this.detailsShipper.postcode || '';
      this.bookingDetails.Booking[0]['Shipper City'] = this.detailsShipper.city || '';
      this.bookingDetails.Booking[0]['Shipper State'] = this.detailsShipper.state || '';
      this.bookingDetails.Booking[0]['Shipper Country'] = this.detailsShipper.country || '';
      this.bookingDetails.Booking[0]['Shipper Attn'] = this.detailsShipper.attn || '';
      this.bookingDetails.Booking[0]['Shipper Tel'] = this.detailsShipper.tel || '';
      this.bookingDetails.Booking[0]['Shipper Fax'] = this.detailsShipper.fax || '';

      this.bookingDetails.Booking[0]['NParty Name1'] = this.detailsNParty.name || '';
      this.bookingDetails.Booking[0]['NParty Add1'] = this.detailsNParty.addressLine1 || '';
      this.bookingDetails.Booking[0]['NParty Add2'] = this.detailsNParty.addressLine2 || '';
      this.bookingDetails.Booking[0]['NParty Add3'] = this.detailsNParty.addressLine3 || '';
      this.bookingDetails.Booking[0]['NParty Add4'] = this.detailsNParty.addressLine4 || '';
      this.bookingDetails.Booking[0]['NParty PostCode'] = this.detailsNParty.postcode || '';
      this.bookingDetails.Booking[0]['NParty City'] = this.detailsNParty.city || '';
      this.bookingDetails.Booking[0]['NParty State'] = this.detailsNParty.state || '';
      this.bookingDetails.Booking[0]['NParty Country'] = this.detailsNParty.country || '';
      this.bookingDetails.Booking[0]['NParty Attn'] = this.detailsNParty.attn || '';
      this.bookingDetails.Booking[0]['NParty Tel'] = this.detailsNParty.tel || '';
      this.bookingDetails.Booking[0]['NParty Fax'] = this.detailsNParty.fax || '';

      this.bookingDetails.Booking[0]['Oversea Agent Desc'] = this.detailsOAgent.name || '';
      this.bookingDetails.Booking[0]['OA Addr1'] = this.detailsOAgent.addressLine1 || '';
      this.bookingDetails.Booking[0]['OA Addr2'] = this.detailsOAgent.addressLine2 || '';
      this.bookingDetails.Booking[0]['OA Addr3'] = this.detailsOAgent.addressLine3 || '';
      this.bookingDetails.Booking[0]['OA Addr4'] = this.detailsOAgent.addressLine4 || '';
      this.bookingDetails.Booking[0]['OA PostCode'] = this.detailsOAgent.postcode || '';
      this.bookingDetails.Booking[0]['OA City'] = this.detailsOAgent.city || '';
      this.bookingDetails.Booking[0]['OA State'] = this.detailsOAgent.state || '';
      this.bookingDetails.Booking[0]['OA Country'] = this.detailsOAgent.country || '';
      this.bookingDetails.Booking[0]['OA Attn'] = this.detailsOAgent.attn || '';
      this.bookingDetails.Booking[0]['OA Tel'] = this.detailsOAgent.tel || '';
      this.bookingDetails.Booking[0]['OA Fax'] = this.detailsOAgent.fax || '';
      this.bookingDetails.Booking[0]['No. of Original BLs'] = this.printDetails['originalBLNo'] || '';
      this.bookingDetails.Booking[0]['BL Remarks'] = this.printDetails['remarks'] || '';
      this.bookingDetails.Booking[0]['Signature Caption'] = this.printDetails['caption'] || '';

      if (this.bookingDetails.Booking[0].Job.BL) {
        const bl = this.bookingDetails.Booking[0].Job.BL;
        const booking = this.bookingDetails.Booking[0];

        booking['Place Of Delivery'] = bl['Place Of Delivery']?.trim() ?? '';
        booking['Place Of Issue'] = bl['Place Of Issue']?.trim() ?? '';
        booking['Place Of Receipt'] = bl['Place Of Receipt']?.trim() ?? '';
        booking['Date Of Issue'] =
          bl['Date Of Issue'] ? new Date(bl['Date Of Issue']).formatString('yyyy-MM-dd HH:mm') : '';

        booking['Place Of Delivery Name'] = bl['Place Of Delivery Desc']?.trim() ?? '';
        booking['Place Of Issue Name'] = bl['Place Of Issue Desc']?.trim() ?? '';
        booking['Place Of Receipt Name'] = bl['Place Of Receipt Desc']?.trim() ?? '';

        booking['Place Of Delivery Country'] = bl['Place Of Delivery Country']?.trim() ?? '';
        booking['Place Of Issue Country'] = bl['Place Of Issue Country']?.trim() ?? '';
        booking['Place Of Receipt Country'] = bl['Place Of Receipt Country']?.trim() ?? '';
      }

      this.bookingDetails.Booking[0]['Total Packages'] =
        this.bookingDetails.Booking[0]['Total Packages'] ?
          String(parseInt(this.bookingDetails.Booking[0]['Total Packages']))
        : '';

      this.designerV3ReportFiles = [this.formatSelectedObject.value];

      this.designerV3ReportData = this.bookingDetails.Booking;
      //console.log('designerV3ReportData', this.designerV3ReportData);
      this.showDesignerV3 = true;

      this.$fullscreenLoading();
    },
  },
  async mounted() {
    this.$fullscreenLoading('Loading Address Details');
    this.loginDetails = await this.$apiCallV2('/Login/GetDetails');
    this.addressDetails['countryList'] = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'COUNTRY' });
    this.addressDetails['postcodeList'] = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'POSTCODE' });
    this.addressDetails['stateList'] = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'STATE' });
    //this.portList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'PORT' });

    const forms = await this.$apiCallV2(`/ReportDesigner/GetAllFiles?folder=HBLForm`); // read all files in HBLForm folder
    const coRef = this.loginDetails.CoRefname.toUpperCase(); // take company reference name to filter out files

    this.formatItems = forms
      .filter((item) => item.filename.includes(coRef))
      .map((item) => ({
        name: item.filename,
        value: item.filename,
      }));

    if (this.formatItems.length > 0) {
      // default to first item if available
      this.formatSelectedObject = this.formatItems[0];
    }
    this.$fullscreenLoading();

    if (this.$route.query['bookingno']) {
      this.selectedBookingNo = this.$route.query['bookingno'];
      this.routeWithBookingNo = true;

      this.dateFilterChecked = false;
      this.searchFilterChecked = true;
      this.searchByValue = this.selectedBookingNo;

      await this.refreshListing();
      //this.previewBookingConfirmationReport(); removed auto preview
    } else {
      this.selectedBookingNo = '';
      this.routeWithBookingNo = false;
      this.refreshFilterClicked();
    }

    if (!this.selectedSearchBy) {
      this.selectedSearchBy = this.searchFilterItems[0];
    }

    if (!this.selectedCriteria) {
      this.selectedCriteria = this.searchCriteriaItems[2];
    }
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
@import '@/css/all.scss';

.print-booking-confirm-main {
  font-size: 12px;
  width: 100%;
  height: 100%;
  padding: 10px 45px;
  display: flex;
  overflow: hidden;

  > .booking-options {
    margin-right: 2.5px;
    flex: 1;
    background-color: white;
    padding: 5px;
    width: 50%;
    overflow-y: auto;
    height: 100%;

    > .table-box-container {
      height: 50%;
      // height: 50%; // ============ change later
    }

    > .details-block {
      display: flex;
      width: 100%;
      position: relative;
      margin-bottom: 2px;

      > .details-column {
        width: calc(100% / 3);
        margin-right: 5px;
      }
    }

    > .filters-and-table-box-controls {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      margin-bottom: 5px;

      > .filters-summary-container {
        margin-right: 5px;
        align-content: center; // vertically align the summary text
        text-align: end; // horizontally align the summary text
      }

      .button-filter-content-container {
        text-align: left;
        cursor: auto;

        .no-filter-container {
          margin-top: 15px;
        }

        .customer-filter-container {
          margin-top: 15px;
        }

        .outstanding-and-job-type-filters {
          display: flex;
          flex-direction: row;

          > .outstanding-dropdown {
            margin-right: 5px;
          }

          > .job-type-dropdown {
            margin-left: 5px;
          }
        }

        .not-printed-filter {
          margin-top: 5px;
          display: flex;
          justify-content: flex-start;
        }

        .refresh-button-container {
          margin-top: 10px;
          display: flex;
          justify-content: flex-end;
        }
      }

      > .select-deselect-all-button {
        margin-left: 5px;
      }
    }
  }

  > .report-preview {
    margin-left: 2.5px;
    flex: 1;
    background-color: white;
    padding: 5px;

    > .user-instructions {
      height: 100%;
      display: flex;
      text-align: center;
      justify-content: center;
      align-items: center;
      font-size: 20px;
    }
  }

  .call-to-action-buttons {
    display: flex;
    margin-top: 10px;
    justify-content: flex-end;
  }

  .call-to-action-buttons > .format-dropdown {
    display: flex;
    align-items: center;
    gap: 5px;
    width: 50%;
  }

  .popup-details {
    display: block;
    height: 100%;
  }
  .tab-block {
    display: flex;
    width: 100%;
    border: 1px solid rgba(0, 0, 0, 0.5);
    margin-top: 10px;
    margin-bottom: 10px;
    position: relative;
    padding-top: 10px;
    padding-left: 5px;

    > .tab-title {
      width: fit-content;
      background-color: white;
      position: absolute;
      top: -10px;
      left: 10px;
      padding: 0 10px;
    }

    > .details-column {
      width: 100%;
      margin-right: 5px;
    }
  }
}
</style>
